import React from "react"
import { Card, CardBody, Col, Input, Label, Row, Table } from "reactstrap"

export default function OtherDimensions(props) {
  const { config } = props
  const onTextInputChange = (e, obj, idx) => {
    const answer = {
      sequence: parseInt(e.target.dataset.sequence),
      answer: e.target.value,
    }

    const oDim = {
      formId: obj.formId,
      sequence: obj.sequence,
      // answers: [answer],
      answer: e.target.value,
    }

    // return config.onChangeJacketOtherDimensions(spec, idx)
    config.handleJacketInput(oDim, "otherDimensions", idx)
    // console.log(oDim);
  }
  return (
    <Card>
      <CardBody>
        <Table bordered>
          <tbody>
            <tr>
              {props?.config?.orderSheets?.jacket?.otherDimensions &&
                props.config.orderSheets.jacket.otherDimensions
                  .filter(dim => dim.item)
                  .map((dim, i) => (
                    <td key={i} className="text-center">
                      {dim.item}
                    </td>
                  ))}
            </tr>
            <tr>
              {props?.config?.orderSheets?.jacket?.otherDimensions &&
                props.config.orderSheets.jacket.otherDimensions
                  .filter(dim => dim.item)
                  .map((dim, i) => {
                    return (
                      <td key={i}>
                        <Input
                          className="me-2"
                          type="text"
                          data-sequence={1}
                          onChange={e => onTextInputChange(e, dim, i)}
                          defaultValue={
                            config?.payload?.jacket?.otherDimensions[i]?.answer
                          }
                        />
                      </td>
                    )
                  })}
            </tr>
          </tbody>
        </Table>
      </CardBody>
    </Card>
  )
}
